import React, { useEffect, useState } from "react";
import axios from "axios";

const FreelancerBankChangeLogsPage = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const apiBaseURL = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchLogs();
  }, [apiBaseURL]);

  const fetchLogs = async () => {
    const token = localStorage.getItem("employeeToken");
    console.log("🔑 Token for auth:", token);

    if (!token) {
      console.warn("🚫 No token, redirecting...");
      window.location.href = "/employee-login";
      return;
    }

    try {
      console.log("📡 Fetching bank change logs...");
      const response = await axios.get(`${apiBaseURL}/api/freelancer-bank-change-logs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      console.log("✅ API response:", response.data);
      setLogs(response.data);
    } catch (err) {
      console.error("❌ Error fetching logs:", err);
      setError("Error fetching logs");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (logId) => {
    const confirmed = window.confirm("Are you sure you want to delete this attempt?");
    if (!confirmed) return;

    const token = localStorage.getItem("employeeToken");

    try {
      await axios.delete(`${apiBaseURL}/api/freelancer-bank-change-logs/${logId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      alert("Deleted successfully");
      setLogs(prev => prev.filter(log => log.id !== logId));
    } catch (err) {
      console.error("❌ Error deleting log:", err);
      alert("Error deleting the log. Please try again.");
    }
  };

  return (
    <div style={{ marginLeft: '10cm', padding: '2rem' }} className="bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Freelancer Bank Change Logs</h1>

      {loading ? (
        <div className="text-gray-600">⏳ Loading logs...</div>
      ) : error ? (
        <div className="text-red-500 font-medium">⚠️ {error}</div>
      ) : logs.length === 0 ? (
        <div className="text-gray-500">No logs available.</div>
      ) : (
        <div className="overflow-x-auto rounded-lg shadow bg-white">
          <table className="min-w-full text-sm text-left text-gray-700">
            <thead className="text-xs uppercase bg-gray-100 text-gray-600 border-b">
              <tr>
                <th className="px-6 py-3">#</th>
                <th className="px-6 py-3">Freelancer ID</th>
                <th className="px-6 py-3">Attempted At</th>
                <th className="px-6 py-3">Action</th>
              </tr>
            </thead>
            <tbody>
              {logs.map((log, index) => (
                <tr key={log.id} className="border-b hover:bg-gray-50">
                  <td className="px-6 py-4">{index + 1}</td>
                  <td className="px-6 py-4">{log.freelancer_id}</td>
                  <td className="px-6 py-4">
                    {log.attempted_at ? new Date(log.attempted_at).toLocaleString() : "—"}
                  </td>
                  <td className="px-6 py-4">
                    <button
                      onClick={() => handleDelete(log.id)}
                      className="bg-red-500 hover:bg-red-600 text-white text-xs font-medium py-1 px-3 rounded"
                    >
                      Delete this attempt
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default FreelancerBankChangeLogsPage;
